import {useMutation, useQueryClient} from "react-query";
import {
  BrandingService,
  CreateThemeRequest,
} from "../../../services/BrandingService";
import {useParams, useNavigate} from "react-router-dom";
import Alert from "react-s-alert";

export const useUpdateBrandingTheme = () => {
  const {organizationId, themeId} = useParams<{
    organizationId: string;
    themeId: string;
  }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(
    async (data: CreateThemeRequest) => {
      const response = await BrandingService.updateTheme(
        organizationId,
        themeId,
        data,
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["themes", "single-theme"]);
        navigate(`/admin/organizations/${organizationId}/edit`);
        Alert.success("Theme updated successfully");
      },
      onError: () => {
        Alert.error("Failed to update theme");
      },
    },
  );
};
